import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import 'antd/dist/reset.css'
import 'animate.css'
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
